import { render, staticRenderFns } from "./VideoFile.vue?vue&type=template&id=4f658e50&"
import script from "./VideoFile.vue?vue&type=script&lang=js&"
export * from "./VideoFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports